import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Columna Izquierda */}
        <div className="footer-left">
          <h4>© 2025 Sol y Luna. Todos los derechos reservados.</h4>

          <div className="footer-links">
            <a href="/about">Sobre Nosotros</a>
            <a href="/privacy">Política de Privacidad</a>
            <a href="/terms">Términos y Condiciones</a>
          </div>

          <div className="footer-payments">
            <h4>Medios de Pago:</h4>
            <div className="payment-icons">
              <img src="/img/visa.png" alt="Visa" className="payment-icon" />
              <img src="/img/mastercard.png" alt="Mastercard" className="payment-icon" />
              <img src="/img/mercadopago.jpeg" alt="Mercado Pago" className="payment-icon" />
            </div>
          </div>
        </div>

        {/* Columna Central */}
        <div className="footer-center">
          <h4>Nuestras Tiendas:</h4>
          <p className="store-location">📍 Chacabuco y Lavalle</p>
          <p className="store-location">📍 9 de Julio y Saavedra</p>
          <p className="store-location">📍 Almafuerte y Quintana</p>

          {/* Redes Sociales */}
          <div className="footer-social">
            <h4>Síguenos en:</h4>
            <div className="social-icons">
              <a href="https://www.instagram.com/solyluna_kiosko/" target="_blank" rel="noopener noreferrer">
                <img src="/img/instagram.png" alt="Instagram" className="social-icon" />
              </a>
              <a href="https://twitter.com/tutienda" target="_blank" rel="noopener noreferrer">
                <img src="/img/twitter.png" alt="Twitter" className="social-icon" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=100075540712787" target="_blank" rel="noopener noreferrer">
                <img src="/img/facebook.png" alt="Facebook" className="social-icon" />
              </a>
            </div>
          </div>
        </div>

        {/* Columna Derecha */}
        <div className="footer-right">
          <h4>Desarrollado por:</h4>
          <a href="https://portafolio-vlobos.web.app" target="_blank" rel="noopener noreferrer">
            <img src="./img/designer-logo.png" alt="Logo del Diseñador" className="designer-logo" />
          </a>
          <div className="visit-pag">
          <p>
            <a href="https://portafolio-vlobos.web.app" target="_blank" rel="noopener noreferrer">
              Visita nuestra página
            </a>
          </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
